
namespace RioERP.Orders {
    export class OrderProductBillingItemsColumns {
        static columnsKey = 'Orders.OrderProductBillingItems';
    }
}